import { getObjectUtil, mapValuesObjectUtil } from 'packages/src'

/**
 * Formats the given data according to the given className and options
 * @private
 * @param  {Object} params
 *         {Object} params.data
 *         {Object} params.className
 *         {Object} params.formatterMap
 *         {Object} params.previousData
 *         {Object} params.key
 *         {Object} params.value
 * @returns {Object}
 */
function formatKey (params) {
  const {
    key,
    value,
    formatterMap
  } = params
  const formatter = formatterMap[key]
  if (!formatter) {
    return value
  }
  return formatter(value, getObjectUtil(params.previousData, key))
}

/**
 * Formats the given data according to the given className and options
 * @param  {Object} params
 *         {Object} params.data
 *         {Object} params.className
 *         {Object} params.formatterMap
 *         {Object} params.previousData
 * @returns {Object}
 */
function formatInstance (params) {
  return mapValuesObjectUtil(params.data, (value, key) =>
    formatKey({
      ...params,
      key,
      value
    })
  )
}

export {
  formatInstance
}
